import { render, staticRenderFns } from "./ActivityRedirectItem.vue?vue&type=template&id=9cfcf0b6&scoped=true&"
import script from "./ActivityRedirectItem.vue?vue&type=script&lang=js&"
export * from "./ActivityRedirectItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cfcf0b6",
  null
  
)

export default component.exports